import Light from '@assets/icons/light.svg'
import { Icon } from './Icon'

export const LightIcon = Icon(Light)
